import React from "react";
import "./Switch.css";

const Switch = ({ isOn, handleToggle, index, freezeSwitch }) => {
  return (
    <div className="switch">
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`react-switch-new-${index}`}
        type="checkbox"
      />
      <label className={`react-switch-label ${freezeSwitch ? 'freeze-switch' : ''}`} htmlFor={`react-switch-new-${index}`}>
        <span className={`react-switch-button ${index}`} />
      </label>
    </div>
  );
};

export default Switch;
